module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrow-right-438c04f0e386360e3dd01c3d35b1636f.svg";